
export class ValidationConstants {
    /* 
    * WHITESPACE can be allowed only after some TEXT
    * WHITESPACE can't be in the end
    * SMALL letters a-z
    * CAPITAL letters A-Z
    */
 
    public static readonly REGEX_TEXT_TYPE1 = /[a-zA-Z]+(\s?[a-zA-Z ]+)$/;
    /* 
    * WHITESPACE can be allowed only after some TEXT
    * WHITESPACE can't be in the end
    * SMALL letters a-z
    * CAPITAL letters A-Z
    * SPECIAL CHARACTERS ,'-. are allowed but on in the start and end
    */
 
    public static readonly REGEX_TEXT_TYPE2 = /^[a-zA-Z]+(\s?[a-zA-Z-,'.\" ]+)*?$/;
    /* 
    * WHITESPACE can't be allowed
    * NUMBERS from 0 - 9
    */
 
    public static readonly REGEX_INTEGER_TYPE3 = /^[0-9]*$/;
    /*
    * NO WHITESPACE allowed
    * NUMBERS 0-9
    * '. can be allowed only ONCE && should appear AFTER a NUMBER only
    */
    public static readonly REGEX_DECIMAL_TYPE4 = /^[0-9]+(\.[0-9]{1,2})?$/;
    // public static readonly REGEX_DECIMAL_TYPE4 = /^[0-9.]*$/;
 
 
   /* 
   * WHITESPACE can be allowed only after some TEXT/NUMBER
   * SMALL letters a-z
   * CAPITAL letters A-Z
   * NUMBERS 0-9
   * SPECIAL characters like #@!*&$%*()^-_+,.?'\";:\/
   */
 
    public static readonly REGEX_ALPHANUMERIC_TYPE5 = /^[a-zA-Z0-9+.]+(\s?[a-zA-Z0-9-#@!*&$%*+=_,.?'\";:()<>{}^[^\]\/\\ ]+)*?$/;
   /* 
   * WHITESPACE can be allowed only after some TEXT
   * SMALL letters a-z
   * CAPITAL letters A-Z
   * No Special
   */
     public static readonly REGEX_ALPHANUMERIC_TYPE6 = /^[a-zA-Z0-9]+(\s?[a-zA-Z0-9. ]+)*?$/;
 
  /* 
   * WHITESPACE can be allowed only after some TEXT
   * SMALL letters a-z
   * CAPITAL letters A-Z
   * SPECIAL characters like !@#$%^&*(){}[]_-+=></\;:'",.`~
   */
  public static readonly REGEX_ALPHA_TYPE7 = /^[a-zA-Z][^0-9]*$/;
 //  ^[a-zA-Z]+(\s?[a-zA-Z-#@!*&$%^<>_+,.?';:(){}[^\]\/\ ]+)*?$
 
 public static readonly REGEX_NEGDECIMAL_TYPE8 = /^-?[0-9]\d*(\.\d+)?$/;
 
 
 ////new for otp login
 public static readonly REGEX_PASSWORD_TYPE11 = /^(\s?[a-zA-Z0-9-#@!*&$%*+=_+,.?'\";:()<>{}^[^\]\/\\]+)?$/;
 
 
 }